module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('h2', [_vm._v(_vm._s(_vm.$t('title.edit-switch')))])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('switch-form', {
    attrs: {
      "switchx": _vm.switchx
    }
  })], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('server-switch-form', {
    attrs: {
      "switchx": _vm.switchx
    }
  })], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-d3955e80!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/switch/SwitchDetails.vue
// module id = 1185
// module chunks = 2